import React, { useState, useEffect } from "react";
import { Input, FormGroup, Label, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getAllBlogCategory } from "../../redux/actions/indexActions";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import CKEditor from "react-ckeditor-component";

const AddEvent = () => {
  const [formData, setFormData] = useState({
    category_id: "",
    event_name: "",
    description: "",
    start_date: "",
    end_date: "",
    url: "",
    website: "",
    location: "",
    contact_person: "",
    email: "",
    mobile: "",
    status: 1,
    thumbnail: "",
  });
  const [errors, setErrors] = useState({});
  const [text, setText] = useState([]);
  const [blogCategories, setBlogCategories] = useState([]);
  const {
    AuthReducer: { auth }
  } = useSelector((state) => state);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllBlogCategory(auth.token));
  }, [auth]);

  const handleText = (e) => {
    const descriptions = e.editor.getData();
    setText(descriptions);
  }

  useEffect(() => {
    axios(`/api/admin/v1/all-blog-category/?type=2`, {
      headers: {
        Authorization: `Bearer ${auth.token}`,
      },
    })
      .then(({ data }) => {
        setBlogCategories(data?.BlogCategories);
      })
      .catch((err) => console.error(err));
  }, []);

  const inputHandler = (e) => {
    const { name, value } = e.target;
    if (name === "thumbnail") {
      setFormData({ ...formData, [name]: e.target.files[0] });
    }
    if (name === "status") {
      setFormData({ ...formData, [name]: e.target.checked ? 1 : 0 });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  const handleSubmit = () => {
    const form = new FormData();
    form.append('category_id', formData.category_id);
    form.append('event_name', formData.event_name);
    form.append('start_date', formData.start_date);
    form.append('end_date', formData.end_date);
    form.append('url', formData.url);
    form.append('website', formData.website);
    form.append('location', formData.location);
    form.append('contact_person', formData.contact_person);
    form.append('email', formData.email);
    form.append('mobile', formData.mobile);
    form.append('description', text);
    form.append('thumbnail', formData.thumbnail);
    form.append('status', formData.status);
    axios
      .post(`/api/admin/v1/add-event`, form, {
        headers: {
          Authorization: `Bearer ${auth?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data?.message);
        navigate(-1);
      })
      .catch((err) => {
        toast.error(err.response.data);
        setErrors(err.response.data);
      });
  };


  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <h4 className="text-white">Add Event</h4>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4">
        <div className="row">
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Event Name <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.event_name)}
                value={formData?.event_name}
                name="event_name"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.event_name} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Category <span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.category_id}
                type="select"
                name="category_id"
                onChange={inputHandler}
              >
                <option value="">Select Option</option>
                {blogCategories?.map?.((item) => {
                  return (
                    <option value={item.id} key={item.id}>
                      {item?.category_name}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.category_id}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Upload Thumbnail</Label>
              <Input
                type="file"
                invalid={Boolean(errors?.thumbnail)}
                name="thumbnail"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.files[0],
                  }))
                }
              />
              <span className="d-block text-danger">{errors?.thumbnail}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Start Date<span className="text-danger fs-4">*</span></Label>
              <Input
                type="datetime-local"
                invalid={Boolean(errors?.start_date)}
                value={formData?.start_date}
                name="start_date"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.start_date} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>End Date <span className="text-danger fs-4">*</span></Label>
              <Input
                type="datetime-local"
                invalid={Boolean(errors?.end_date)}
                value={formData?.end_date}
                name="end_date"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.end_date} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Location <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.location)}
                value={formData?.location}
                name="location"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.location} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>URL</Label>
              <Input
                invalid={Boolean(errors?.url)}
                value={formData?.url}
                name="url"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.url} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Website</Label>
              <Input
                invalid={Boolean(errors?.website)}
                value={formData?.website}
                name="website"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.website} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Contact Person <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.contact_person)}
                value={formData?.contact_person}
                name="contact_person"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.contact_person} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Email <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.email)}
                value={formData?.email}
                name="email"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.email} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Mobile <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.mobile)}
                value={formData?.mobile}
                name="mobile"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.mobile} </span>
            </FormGroup>
          </div>
          <div className="col-md-9 offset-md-1">
            <FormGroup>
              <Label>Description</Label>
              <CKEditor
                content={text}
                events={{
                  "change": handleText
                }}
              />
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup switch>
              <Input
                type="switch"
                checked={formData?.status}
                onChange={inputHandler}
                name="status"
              />
              <Label check>Status</Label>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-4">
            <Button color="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button className="ms-3" onClick={() => navigate(-1)}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEvent;
